import React from "react";
import { Edit, Trash2 } from "lucide-react";
import { API_BASE } from "../../../../config/api";
import { SystemAnnouncement } from "../../../../types/features/administration/SystemAnnouncement";

interface AnnouncementCardProps {
  announcement: SystemAnnouncement;
  onEdit: (announcement: SystemAnnouncement) => void;
  onDelete: (id: string) => void;
}

export const AnnouncementCard: React.FC<AnnouncementCardProps> = ({ announcement, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
      {announcement.image && (
        <img src={`${API_BASE}${announcement.image}`} alt={announcement.title} className="w-full h-48 object-cover" />
      )}
      <div className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="text-lg font-semibold text-gray-900">{announcement.title}</h3>
          <div className="flex gap-2">
            <button
              onClick={() => onEdit(announcement)}
              className="p-1 text-blue-600 hover:bg-blue-50 rounded"
              aria-label="Modifier"
            >
              <Edit className="w-4 h-4" />
            </button>
            <button
              onClick={() => onDelete(announcement.id)}
              className="p-1 text-red-600 hover:bg-red-50 rounded"
              aria-label="Supprimer"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
        <p className="text-gray-600 text-sm mb-3 line-clamp-3">{announcement.description}</p>
        <div className="flex items-center gap-2 flex-wrap">
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${
              announcement.status === "ACTIVE" ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-800"
            }`}
          >
            {announcement.status === "ACTIVE" ? "Active" : "Désactivée"}
          </span>
          {announcement.is_block && (
            <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">Bloquant</span>
          )}
        </div>
      </div>
    </div>
  );
};
